// ** React Imports
import { useEffect } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";
import { vendor } from "store/vendor";
import { injectReducer } from "store/reducer";
import { loadUserpanelPhotosReducer } from "store/asyncReducers";

// ** Components
import Block from "components/layout/Block";
import EditPhotoContent from "./EditPhotoContent";

// #####################################################

const EditPhoto = ({
	match: {
		params: { id },
	},
}) => {
	const reducerPhotos = useSelector((state) => state.userpanelPhotos);

	useEffect(() => {
		const loadReducer = async () => {
			const reducerPhotos = await loadUserpanelPhotosReducer();

			injectReducer(vendor.store, {
				key: "userpanelPhotos",
				reducer: reducerPhotos,
			});
		};
		if (!reducerPhotos) {
			loadReducer();
		}
	}, []);

	// #####################################################

	return <Block>{reducerPhotos && <EditPhotoContent photoId={id} />}</Block>;
};

// #####################################################

export default EditPhoto;

// #####################################################
